import routes from '@/constants/routes';

export default [
  {
    title: 'X',
    icon: 'socials-x',
    link: routes.X,
  },
  {
    title: 'Tiktok',
    icon: 'socials-tiktok',
    link: routes.TIKTOK,
  },
  {
    title: 'Instagram',
    icon: 'socials-instagram',
    link: routes.INSTAGRAM,
  },
  {
    title: 'Youtube',
    icon: 'socials-youtube',
    link: routes.YOUTUBE,
  },
];
